export default __webpack_public_path__ + "static/media/image.7520d8fb.png";